// ** Gatsby
import { Link } from "gatsby"

// ** Helpers
import { classNames, parseLink } from "../../utils/helpers"

// ** Custom Componentts
import Button from "../Button"
import Container from "../Container"
import Text from "../Text"

const SectionButtonAction = ({ section }: any) => {
  const { listItems } = section

  return (
    <Container
      fullWidthOnMobile={false}
      className="flex flex-col w-full gap-2 lg:flex-row my-0 px-10 sm:px-40 lg:px-0 mx-auto md:pt-0 md:mt-0 lg:max-w-4xl lg:justify-between lg:gap-10"
    >
      {listItems.map((item: any, idx: any) => (
        <Link
          key={idx}
          to={parseLink(item.linkPrimary)}
          className="lg:w-1/2"
        >
          <Button
            className={classNames(
              idx === 0
                ? "bg-blue-500 hover:bg-blue-900"
                : "bg-orange-500 hover:bg-yellow-600",
              "text-white text-center my-2 md:my-0 lg:hover:shadow-xl lg:shadow-md py-5 lg:py-[30px] lg:px-[10px]"
            )}
          >
            <Text variant="large">{item.linkPrimary?.title}</Text>
          </Button>
        </Link>
      ))}
    </Container>
  )
}

export default SectionButtonAction
